import { useGuestAccess } from '../contexts/GuestAccessContext';
import { GuestHomeEditorial } from './GuestHomeEditorial';
import { GuestLandingPage } from './GuestLandingPage';

export function HomePage() {
  const access = useGuestAccess();

  if (access.status !== 'ready') {
    return null;
  }

  const { experience } = access;

  if (experience.accessMode === 'public_visitor') {
    return <GuestLandingPage experience={experience} />;
  }

  return <GuestHomeEditorial access={access} experience={experience} />;
}
